import { useState, useEffect } from "react"
import { Button, Form, Modal } from "react-bootstrap"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2"
import { statusComments } from "../utils/utils";
import { LMSBASEURL } from "../config/apiUrls";

const StatusChangeModal = ({ show, onHide, studentId, newStatus, onConfirm , isHired, hiredModalDetails, fetchPlacements, }) => {
  const [interviewDateTime, setInterviewDateTime] = useState(null);
  const [comment, setComment] = useState("");
  const [errors, setErrors] = useState({});
  const [submitting,setSubmitting] = useState(false)
  const loginUser = sessionStorage.getItem("id")
  const [offerForm, setOfferForm] = useState({
    company: "",
    role: hiredModalDetails?.emp?.employment_title || "",
    package: "",
    placementType: "",
    offerDate: new Date().toISOString().split("T")[0],
    joiningDate: null,
    file: null 
  });
  useEffect(()=>{
    setOfferForm({
      company: hiredModalDetails?.org?.organisation_name,
      role: hiredModalDetails?.emp?.employment_title || "",
      package: hiredModalDetails?.emp?.salary || "",
      placementType: "",
      offerDate: new Date().toISOString().split("T")[0],
      joiningDate: null,
      file: null 
    })
  },[hiredModalDetails,show])

  const token = process.env.REACT_APP_API_TOKEN;

  useEffect(() => {
    if (newStatus === "accept") {
      setComment(statusComments.accept);
    } else {
      setComment(statusComments?.[newStatus] || "Application status updated.");
    }
  }, [newStatus, show]);

  const handleDateChange = (date) => {
    setInterviewDateTime(date);

    if (date) {
      const formattedDate = date.toLocaleDateString();
      const formattedTime = date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
      setComment(`${statusComments.accept} Your interview is scheduled on ${formattedDate} at ${formattedTime}.`);
    }
  };

  const handleConfirm = () => {
    let finalComment = comment.trim();

    if (newStatus === "accept") {
      if (!interviewDateTime) {
        Swal.fire({
            icon: 'error',
            title: 'Date and time',
            text: "Please select date and time",
            confirmButtonText: 'OK',
            confirmButtonColor: '#dc3545'
        });
        return;
      }
    }

    if (!finalComment) {
      finalComment = "Application status updated.";
    }

    onConfirm(studentId, newStatus, finalComment, interviewDateTime);
    onHide();
  };

  const validateForm = () => {
    let newErrors = {};

    if (!offerForm.company) newErrors.company = "Company name is required";
    if (!offerForm.role) newErrors.role = "Role is required";
    if (!offerForm.package) newErrors.package = "Package is required";
    if (!offerForm.placementType) newErrors.placementType = "Placement type is required";
    if (!offerForm.offerDate) newErrors.offerDate = "Offer date is required";
    if (!offerForm.joiningDate) newErrors.joiningDate = "Joining date is required";
    
    // File validation for joining letter
    if (!offerForm.file) {
      newErrors.file = "Joining letter is required (.pdf/.doc/.docx)";
    } else {
      const allowedTypes = ["application/pdf", "application/msword", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"];
      if (!allowedTypes.includes(offerForm.file.type)) {
        newErrors.file = "Only PDF, DOC, DOCX files are allowed";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      setSubmitting(true)
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);
      myHeaders.append("Accept", "application/json");

      const formdata = new FormData();
      formdata.append("student_id", hiredModalDetails.student_id);
      formdata.append("job_id", hiredModalDetails?.emp?.id);
      formdata.append("company_id", hiredModalDetails?.emp?.organisation_id);
      formdata.append("company_name", hiredModalDetails?.org?.organisation_name);
      formdata.append("role", offerForm.role);
      formdata.append("package", offerForm.package);
      formdata.append("type", offerForm.placementType);
      formdata.append("status", "Placed");
      formdata.append("offer_date", offerForm.offerDate);
      formdata.append("joining_date", offerForm.joiningDate);
      formdata.append("offer_letter", offerForm.file); 
      formdata.append("offer_letter_acceptance", "Placed");
      formdata.append("location", hiredModalDetails?.emp?.location[0]?.city?.name);
      formdata.append("application_id", hiredModalDetails?.id);
      formdata.append("updated_by",loginUser);
      formdata.append("comment","The offer has been issued successfully.");

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      const response = await fetch(`${LMSBASEURL}/api/placements`, requestOptions);
      const result = await response.json();

      if (response.ok) {
        fetchPlacements();
        Swal.fire({
          icon:"success",
          text:"The offer letter Send Successfully.",
        })
        setOfferForm({
          company: "",
          role: "",
          package:  "",
          placementType: "",
          offerDate: new Date().toISOString().split("T")[0],
          joiningDate: null,
          file: null 
        });
        onHide();
      } else {
        const errorMessage =
          result?.errors?.offer_letter?.[0] ||
          result?.message || "Failed to Submit Offer Form";

        onHide();
        setOfferForm({
          company: "",
          role: "",
          package:  "",
          placementType: "",
          offerDate: new Date().toISOString().split("T")[0],
          joiningDate: null,
          file: null 
        });
        Swal.fire({
          icon:response.status ==409 ? "warning":"error",
          text:response.status ==409 ? "The offer letter has already been sent to this student.":errorMessage
        })
        fetchPlacements();
      }
    } catch (error) {
      fetchPlacements();
    } finally{
      setSubmitting(false)
    }
  };

  const handleOfferDateChange = (field, value) => {
    const updatedForm = { ...offerForm, [field]: value };
    setOfferForm(updatedForm);

    const newErrors = { ...errors, [field]: "" };

    if (field === "joiningDate" && updatedForm.offerDate && value) {
      const offer = new Date(updatedForm.offerDate);
      const join = new Date(value);

      if (join < offer) {
        newErrors.joiningDate = "Joining date must be after the offer date.";
      }
    }

    setErrors(newErrors);
  };

  const HiredForm=()=>{
    return(
      <form onSubmit={handleFormSubmit}>
        <div className="mb-3">
          <label className="form-label">Company</label>
          <input type="text" className="form-control" value={offerForm.company} disabled />
          {errors.company && <small className="text-danger">{errors.company}</small>}
        </div>

        <div className="mb-3">
          <label className="form-label">Job Role</label>
          <input type="text" className="form-control"
            value={offerForm.role}
            disabled
            // onChange={e => setOfferForm({ ...offerForm, role: e.target.value })}
          />
          {errors.role && <small className="text-danger">{errors.role}</small>}
        </div>

        <div className="mb-3">
          <label className="form-label">Package (in LPA)<span className="text-danger">*</span></label>
          <input
            type="number"
            className="form-control"
            value={offerForm.package?.toString() || ""}
            onChange={(e) => {
              setOfferForm({
                ...offerForm,
                package: e.target.value
              });
            }}
            autoFocus={true}
            onInput={(e) => {
              if (e.target.value.length > 1) {
                e.target.value = e.target.value.slice(0, 10);
              }
            }}
          />
          {errors.package && <small className="text-danger">{errors.package}</small>}
        </div>

        <div className="mb-3">
          <label className="form-label">Placement Type<span className="text-danger">*</span></label>
          <select className="form-select"
            value={offerForm.placementType}
            onChange={e => setOfferForm({ ...offerForm, placementType: e.target.value })}
          >
            <option value="">Select</option>
            <option value="On Campus">On Campus</option>
            <option value="Off Campus">Off Campus</option>
          </select>
          {errors.placementType && <small className="text-danger">{errors.placementType}</small>}
        </div>

        <div className="mb-3">
          <label className="form-label">Offer Date<span className="text-danger">*</span></label>
          <input type="date" className="form-control"
            value={offerForm.offerDate}
            min={new Date(Date.now() - 10 * 24 * 60 * 60 * 1000)
            .toISOString()
            .split("T")[0]} 
            onClick={(e) => {
              e.target.type = "date";
              e.target.showPicker?.()
            }}
            onChange={(e) => handleOfferDateChange("offerDate", e.target.value)}
            // onChange={e => setOfferForm({ ...offerForm, offerDate: e.target.value })}
          />
          {errors.offerDate && <small className="text-danger">{errors.offerDate}</small>}
        </div>

        <div className="mb-3">
          <label className="form-label">Joining Date<span className="text-danger">*</span></label>
          <input
            className="form-control"
            type={offerForm.joiningDate ? "date" : "text"}
            value={offerForm.joiningDate}
            placeholder="Select date"
            min={offerForm.offerDate || new Date().toISOString().split("T")[0]}
            onClick={(e) => {
              e.target.type = "date";
              e.target.showPicker?.()
            }}
            onBlur={(e) => !e.target.value && (e.target.type = "text")}
            onChange={e => setOfferForm({ ...offerForm, joiningDate: e.target.value })}
          />
          {errors.joiningDate && <small className="text-danger">{errors.joiningDate}</small>}
        </div>

        <div className="mb-3">
          <label className="form-label">Upload Joining Letter (PDF/DOC)<span className="text-danger">*</span></label>
          <input
            type="file"
            className="form-control"
            accept=".pdf,.doc,.docx"
            onChange={e => setOfferForm({ ...offerForm, file: e.target.files[0] })}
          />
          <small className="text-muted">Allowed formats: PDF, DOC, DOCX</small><br/>
          {offerForm.file && (
            <p className="mt-1">Selected file: {offerForm.file.name}</p>
          )}
          {errors.file && <small className="text-danger">{errors.file}</small>}
        </div>
        <div className="text-center">
          <button type="submit" disabled={submitting} className="btn btn-success">{submitting? "Please Wait":"Send Offer"}</button>
        </div>

      </form>
    )
  }

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>{isHired ? 'Placement information':'Confirm Status Change'}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ height: isHired ? "75vh": newStatus === "hired" ? "35vh" : newStatus === "accept" ? "55vh": "75vh", overflowY: newStatus === "hired" ? "auto": "visible" }}>
        {isHired ? <HiredForm/>:
        <>
          <h5>
            Do you really want to change status to{" "}
            <b className="text-danger">{newStatus === "accept" ? "Shortlisted" : newStatus}</b>?
          </h5>

          {newStatus === "accept" && (
            <Form.Group className="mb-3">
              <Form.Label>Select Interview Date & Time</Form.Label>
              <DatePicker
                selected={interviewDateTime}
                onChange={handleDateChange}
                showTimeSelect
                timeIntervals={15}
                dateFormat="MMMM d, yyyy h:mm aa"
                placeholderText="Click to select date & time"
                className="form-control"
                minDate={new Date()}
              />
            </Form.Group>
          )}

          <Form.Group>
            <Form.Label>Custom Message</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </Form.Group>
        </>}

      </Modal.Body>
      <Modal.Footer>
        {isHired? null:
        <>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleConfirm}>
          Yes, change it!
        </Button>
        </>}
      </Modal.Footer>
    </Modal>
  );
};

export default StatusChangeModal